import { MonthlyPrayerTimes } from '../types';

export const marchPrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "04:29",
    shoruk: "06:38",
    dhuhr: "12:05",
    asr: "14:35",
    maghrib: "17:22",
    isha: "19:15",
  },
  2: {
    fajr: "04:26",
    shoruk: "06:35",
    dhuhr: "12:05",
    asr: "14:37",
    maghrib: "17:25",
    isha: "19:18",
  },
  3: {
    fajr: "04:23",
    shoruk: "06:33",
    dhuhr: "12:05",
    asr: "14:39",
    maghrib: "17:27",
    isha: "19:20",
  },
  4: {
    fajr: "04:20",
    shoruk: "06:30",
    dhuhr: "12:05",
    asr: "14:40",
    maghrib: "17:30",
    isha: "19:23",
  },
  5: {
    fajr: "04:17",
    shoruk: "06:27",
    dhuhr: "12:04",
    asr: "14:42",
    maghrib: "17:32",
    isha: "19:25",
  },
  6: {
    fajr: "04:14",
    shoruk: "06:24",
    dhuhr: "12:04",
    asr: "14:44",
    maghrib: "17:34",
    isha: "19:28",
  },
  7: {
    fajr: "04:11",
    shoruk: "06:21",
    dhuhr: "12:04",
    asr: "14:45",
    maghrib: "17:37",
    isha: "19:30",
  },
  8: {
    fajr: "04:08",
    shoruk: "06:18",
    dhuhr: "12:04",
    asr: "14:47",
    maghrib: "17:39",
    isha: "19:33",
  },
  9: {
    fajr: "04:05",
    shoruk: "06:15",
    dhuhr: "12:03",
    asr: "14:49",
    maghrib: "17:42",
    isha: "19:35",
  },
  10: {
    fajr: "04:02",
    shoruk: "06:12",
    dhuhr: "12:03",
    asr: "14:50",
    maghrib: "17:44",
    isha: "19:38",
  },
  11: {
    fajr: "03:58",
    shoruk: "06:09",
    dhuhr: "12:03",
    asr: "14:52",
    maghrib: "17:46",
    isha: "19:40",
  },
  12: {
    fajr: "03:55",
    shoruk: "06:06",
    dhuhr: "12:03",
    asr: "14:54",
    maghrib: "17:49",
    isha: "19:43",
  },
  13: {
    fajr: "03:52",
    shoruk: "06:03",
    dhuhr: "12:02",
    asr: "14:55",
    maghrib: "17:51",
    isha: "19:46",
  },
  14: {
    fajr: "03:48",
    shoruk: "06:01",
    dhuhr: "12:02",
    asr: "14:57",
    maghrib: "17:54",
    isha: "19:48",
  },
  15: {
    fajr: "03:45",
    shoruk: "05:58",
    dhuhr: "12:02",
    asr: "14:58",
    maghrib: "17:56",
    isha: "19:51",
  },
  16: {
    fajr: "03:42",
    shoruk: "05:55",
    dhuhr: "12:02",
    asr: "15:00",
    maghrib: "17:58",
    isha: "19:54",
  },
  17: {
    fajr: "03:38",
    shoruk: "05:52",
    dhuhr: "12:01",
    asr: "15:02",
    maghrib: "18:01",
    isha: "19:57",
  },
  18: {
    fajr: "03:35",
    shoruk: "05:49",
    dhuhr: "12:01",
    asr: "15:03",
    maghrib: "18:03",
    isha: "19:59",
  },
  19: {
    fajr: "03:31",
    shoruk: "05:46",
    dhuhr: "12:01",
    asr: "15:05",
    maghrib: "18:06",
    isha: "20:02",
  },
  20: {
    fajr: "03:27",
    shoruk: "05:43",
    dhuhr: "12:00",
    asr: "15:06",
    maghrib: "18:08",
    isha: "20:05",
  },
  21: {
    fajr: "03:24",
    shoruk: "05:40",
    dhuhr: "12:00",
    asr: "15:08",
    maghrib: "18:10",
    isha: "20:08",
  },
  22: {
    fajr: "03:20",
    shoruk: "05:37",
    dhuhr: "12:00",
    asr: "15:09",
    maghrib: "18:13",
    isha: "20:11",
  },
  23: {
    fajr: "03:16",
    shoruk: "05:34",
    dhuhr: "12:00",
    asr: "15:11",
    maghrib: "18:15",
    isha: "20:14",
  },
  24: {
    fajr: "03:13",
    shoruk: "05:31",
    dhuhr: "11:59",
    asr: "15:12",
    maghrib: "18:17",
    isha: "20:17",
  },
  25: {
    fajr: "03:09",
    shoruk: "05:28",
    dhuhr: "11:59",
    asr: "15:13",
    maghrib: "18:20",
    isha: "20:20",
  },
  26: {
    fajr: "03:05",
    shoruk: "05:25",
    dhuhr: "11:59",
    asr: "15:15",
    maghrib: "18:22",
    isha: "20:23",
  },
  27: {
    fajr: "03:01",
    shoruk: "05:22",
    dhuhr: "11:58",
    asr: "15:16",
    maghrib: "18:25",
    isha: "20:26",
  },
  28: {
    fajr: "02:57",
    shoruk: "05:19",
    dhuhr: "11:58",
    asr: "15:18",
    maghrib: "18:27",
    isha: "20:29",
  },
  29: {
    fajr: "02:53",
    shoruk: "05:16",
    dhuhr: "11:58",
    asr: "15:19",
    maghrib: "18:29",
    isha: "20:32",
  },
  30: {
    fajr: "03:49",
    shoruk: "06:13",
    dhuhr: "12:57",
    asr: "16:20",
    maghrib: "19:32",
    isha: "21:35",
  },
  31: {
    fajr: "03:44",
    shoruk: "06:10",
    dhuhr: "12:57",
    asr: "16:22",
    maghrib: "19:34",
    isha: "21:39",
  },
};